"use client"
import {
    FacebookShareButton,
    FacebookIcon,
    PinterestShareButton,
    PinterestIcon,
    RedditIcon,
    RedditShareButton,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    WhatsappIcon,
    LinkedinShareButton,
    LinkedinIcon
  } from "next-share";

  type BlogShareDetails = {
    slug?: string;
    title?: string;
  };

  export default function BlogSocialShareIcons({ blogDetails }: { blogDetails: BlogShareDetails }) {
    return (
      <>
      <div>
        <FacebookShareButton
          url={`${process.env.NEXT_PUBLIC_BASE_URL}/blog/${blogDetails?.slug}`}
          quote={`${blogDetails?.title}`}
        >
          <FacebookIcon size={32} round className="grayscale" />
        </FacebookShareButton>

        <PinterestShareButton
          url={`${process.env.NEXT_PUBLIC_BASE_URL}/blog/${blogDetails?.slug}`}
          media={`${blogDetails?.title}`}
        >
          <PinterestIcon size={32} round className="grayscale"/>
        </PinterestShareButton>

        <RedditShareButton
          url={`${process.env.NEXT_PUBLIC_BASE_URL}/blog/${blogDetails?.slug}`}
          title={`${blogDetails?.title}`}
        >
          <RedditIcon size={32} round className="grayscale" />
        </RedditShareButton>
  
        <TwitterShareButton
          url={`${process.env.NEXT_PUBLIC_BASE_URL}/blog/${blogDetails?.slug}`}
          title={`${blogDetails?.title}`}
        >
          <TwitterIcon size={32} round  className="grayscale"/>
        </TwitterShareButton>
  
        <WhatsappShareButton
          url={`${process.env.NEXT_PUBLIC_BASE_URL}/blog/${blogDetails?.slug}`}
          title={`${blogDetails?.title}`}
          separator=":: "
        >
          <WhatsappIcon size={32} round  className="grayscale"/>
        </WhatsappShareButton>
  
        <LinkedinShareButton
          url={`${process.env.NEXT_PUBLIC_BASE_URL}/blog/${blogDetails?.slug}`}
        >
          <LinkedinIcon size={32} round className="grayscale"/>
        </LinkedinShareButton>
        </div>
      </>
    );
  }
